import React, { useState, useEffect } from "react";
import {
  Switch,
  FormControl,
  FormControlLabel,
  FormHelperText
} from "@material-ui/core";


export default function CreditSwitchField(
  {
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues,
  }) {

  const [value, setValue] = useState(null);

  useEffect(() => {
    if (currentMetafields[0].meta_value_boolean !== value) {
      setValue(currentMetafields[0].meta_value_boolean);
      // console.log(currentMetafields[0].meta_key + ': setValue ', currentMetafields[0].meta_value_boolean);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null && currentMetafields[0].meta_value_boolean !== value) {
      setMetafieldsValues(currentMetafields, value);
      // console.log(currentMetafields[0].meta_key + ': setMetafieldsValues ', value);
    }
  }, [value]);

  if (!fieldConfig)
    return null;

  const helperText = hideChannels
    ? null
    : (currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")));


  return (
    <FormControl component="fieldset">
      <FormControlLabel
        key={currentMetafields[0].id}
        control={
          <Switch
            checked={value ? value : false}
            onChange={(e) => {
              setValue(e.target.checked);
            }}
            color="primary"
            size="small"
          />
        }
        label={fieldConfig.label}
      />
      <FormHelperText>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}
